import {useCallback} from 'react';
import {useReservation} from 'context/reservation';
import {environments} from 'configs';
import {ORIGINS} from '@guestapp/sdk';
import ChekinPro from 'ChekinPro';
import {useTaxes} from './taxes';
import {useGuestGroup} from './useGuestGroup';

function useReservationSettings() {
  const {seasonEntity} = useTaxes();
  const {allowEditingGuestNumber, data: reservation} = useReservation();
  const {areAllGuestsRegistered} = useGuestGroup();
  const hasReservationNumber = Boolean(reservation?.booking_reference);

  const showReservationNumberBox =
    reservation &&
    [ORIGINS.guesty, ORIGINS.guesty2].includes(reservation.origin) &&
    hasReservationNumber;

  const checkCanEditReservationDetails = useCallback(() => {
    const isSDKMode = environments.VITE_APP_IS_SDK;
    const thereAreTaxRules = Boolean(seasonEntity?.rules && seasonEntity.rules.length);

    if (thereAreTaxRules) {
      return true;
    }

    if (!isSDKMode || ChekinPro.getSettings()?.canEditReservationDetails === undefined) {
      return allowEditingGuestNumber;
    }

    return ChekinPro.getSettings()?.canEditReservationDetails;
  }, [allowEditingGuestNumber, seasonEntity]);

  const checkCanShowRegisterButton = useCallback(() => {
    const isSDKMode = environments.VITE_APP_IS_SDK;

    if (isSDKMode) {
      return (
        ChekinPro.getSettings()?.canEditReservationDetails || !areAllGuestsRegistered
      );
    }

    return allowEditingGuestNumber || !areAllGuestsRegistered;
  }, [areAllGuestsRegistered, allowEditingGuestNumber]);

  return {
    checkCanEditReservationDetails,
    checkCanShowRegisterButton,
    showReservationNumberBox,
  };
}

export {useReservationSettings};
